{ parse } = require './query-string'
{ hasPushState } = require './check-status'

getQuery = ->
  if hasPushState
    location.search.replace '?', ''
  else
    location.hash.match(/^.*\?(.*)$/)?[1]  # get hash in params

module.exports =

  ###
  @return [String] query string
  ###
  getQuery: ->
    getQuery()

  ###
  @return [Object] query object
  ###
  getParams: ->
    query = getQuery()
    if query then parse(query) else {}

  ###
  @return [Object] query object
  ###
  getParam: (name) ->
    query = getQuery()
    parse(query)?[name] if query



// WEBPACK FOOTER //
// ./webpack/requires/components/paramas.coffee